<div>
  <div class="tiptap-controls">
    <button
      type="button"
      (click)="editor.chain().focus().toggleBold().run()"
      [ngClass]="{ active: editor.isActive('bold') }"
    >
      <i class="fa-solid fa-bold"></i>
    </button>
    <button
      type="button"
      (click)="editor.chain().focus().toggleItalic().run()"
      [ngClass]="{ active: editor.isActive('italic') }"
    >
      <i class="fa-solid fa-italic"></i>
    </button>
    <button
      type="button"
      (click)="editor.chain().focus().toggleStrike().run()"
      [ngClass]="{ active: editor.isActive('strike') }"
    >
      <i class="fa-solid fa-strikethrough"></i>
    </button>
    <button
      type="button"
      (click)="editor.chain().focus().toggleUnderline().run()"
      [ngClass]="{ active: editor.isActive('underline') }"
    >
      <i class="fa-solid fa-underline"></i>
    </button>
    <button
      type="button"
      *ngIf="showList"
      (click)="editor.chain().focus().toggleOrderedList().run()"
      [ngClass]="{ active: editor.isActive('orderedList') }"
    >
      <i class="fa-solid fa-list-ol"></i>
    </button>
    <button
      type="button"
      *ngIf="showList"
      (click)="editor.chain().focus().toggleBulletList().run()"
      [ngClass]="{ active: editor.isActive('bulletList') }"
    >
      <i class="fa-solid fa-list-ul"></i>
    </button>
    <button
      *ngIf="showHeading"
      type="button"
      (click)="editor.chain().focus().toggleHeading({ level: 1 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 1 }) }"
    >
      <strong>h1</strong>
    </button>
    <button
      *ngIf="showHeading"
      type="button"
      (click)="editor.chain().focus().toggleHeading({ level: 2 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 2 }) }"
    >
      <strong>h2</strong>
    </button>
    <button
      type="button"
      *ngIf="showHeading"
      (click)="editor.chain().focus().toggleHeading({ level: 3 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 3 }) }"
    >
      <strong>h3</strong>
    </button>
    <button
      type="button"
      *ngIf="showHeading"
      (click)="editor.chain().focus().toggleHeading({ level: 4 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 4 }) }"
    >
      <strong>h4</strong>
    </button>
    <button
      type="button"
      *ngIf="showHeading"
      (click)="editor.chain().focus().toggleHeading({ level: 5 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 5 }) }"
    >
      <strong>h5</strong>
    </button>
    <button
      type="button"
      *ngIf="showHeading"
      (click)="editor.chain().focus().toggleHeading({ level: 6 }).run()"
      [ngClass]="{ active: editor.isActive('heading', { level: 6 }) }"
    >
      <strong>h6</strong>
    </button>

    <select (change)="fontSizeChange($event)" *ngIf="showFontSize">
      <option value="">Font Size</option>
      <option value="11" [selected]="fontSize == '11'">11px</option>
      <option value="12" [selected]="fontSize == '12'">12px</option>
      <option value="13" [selected]="fontSize == '13'">13px</option>
      <option value="14" [selected]="fontSize == '14'">14px</option>
      <option value="15" [selected]="fontSize == '15'">15px</option>
      <option value="16" [selected]="fontSize == '16'">16px</option>
      <option value="17" [selected]="fontSize == '17'">17px</option>
      <option value="18" [selected]="fontSize == '18'">18px</option>
      <option value="19" [selected]="fontSize == '19'">19px</option>
      <option value="20" [selected]="fontSize == '20'">20px</option>
    </select>
    <color-picker
      (change)="editor.chain().focus().setColor($event.target.value).run()"
      name="color"
      [value]="editor.getAttributes('textStyle').color"
    ></color-picker>
  </div>

  <tiptap-editor
    [editor]="editor"
    (ngModelChange)="onChange.emit($event)"
    [ngModel]="value"
  ></tiptap-editor>
</div>
